import { cn } from '@/lib/utils';
import { useCustomToolBuilder } from '../../builder/builder-context';
import { resultPort } from '../ports';
import { CARD, CardHeader, Row } from './card';
import { Port } from './port';

/** What the AI gets back: one result per step, keyed by step id. */
export const ResultNode = () => {
	const { draft } = useCustomToolBuilder();
	return (
		<div className={cn(CARD, 'border-gray-300')}>
			<CardHeader icon={null} title='Returns' />
			<div className='py-1'>
				{draft.steps.length ? (
					draft.steps.map((step) => (
						<Row key={step.id}>
							<Port id={resultPort(step.id)} type='target' side='left' tone='run' connectable={false} />
							<span className='min-w-0 truncate font-mono text-[11px] leading-4 text-gray-900'>{step.id}</span>
						</Row>
					))
				) : (
					<Row>
						<span className='truncate text-[11px] leading-4 text-gray-800'>One result per step</span>
					</Row>
				)}
			</div>
		</div>
	);
};
